export default () => ({
  overview: null,
  renderableInputs: null,
  form: null,
  loadingEditPage: false,
});
